import React from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const SRATable = ({ sras, activeTab, isLoading }) => {
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const columns = [
    {
      field: "pr",
      headerName: "Sourcing No.",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontWeight: "bold" }} className="table-title">
          {params.row.pr}
        </span>
      ),
    },
    {
      field: "title",
      headerName: "Project Title",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
    },
    {
      field: "buyer",
      headerName: "Buyer Name",
      flex: 1,
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1.3,
      renderCell: (params) => {
        const statusColors = {
          PENDING: "#FFCD82",
          APPROVED: "#35D85B",
          QUERY: "#EA981F",
          REJECTED: "#FA6459",
        };

        const statusLabels = {
          PENDING: "PENDING",
          APPROVED: "APPROVED",
          QUERY: "QUERY",
          REJECTED: "REJECTED",
        };
        return (
          <>
            <span
              style={{
                background: statusColors[params.row.status],
                borderRadius: "15px",
                padding: "5px 15px",
                fontWeight: 600,
              }}
            >
              {params.row.status
                ? activeTab === "APPROVED" && params.row.status === "PENDING"
                  ? `APPROVED BY ${params.row.stage - 1}/${
                      params.row.numberOfApprovers
                    }`
                  : activeTab === "APPROVED" && params.row.status === "QUERY"
                  ? `QUERY BY APPROVER ${params.row.stage}`
                  : statusLabels[params.row.status]
                : ""}
            </span>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ display: "inline-flex", gap: 1 }}>
          <Button
            className="btn-outlined"
            sx={{
              margin: "0 !important",
              padding: "0 !important",
              width: "auto !important",
            }}
            onClick={() => {
              localStorage.setItem("activeTab", activeTab);
              navigate(`/dashboard/${params.row.sraId}`);
            }}
          >
            View
          </Button>
          {activeTab === "QUERY" && storedUser.userRole[0] === "BUYER" && (
            <Button
              className="btn-outlined"
              sx={{
                margin: "0 !important",
                padding: "0 !important",
                width: "auto !important",
              }}
              onClick={() => {
                localStorage.setItem("activeTab", activeTab);
                navigate(`/dashboard/edit-sra/${params.row.sraId}`);
              }}
            >
              Edit
            </Button>
          )}
        </Box>
      ),
    },
  ].filter(Boolean);

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };

  const rows =
    sras &&
    sras.map((sra) => ({
      ...sra,
      createdDate: formatDateTime(sra.createdDate),
    }));
  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.sraId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default SRATable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
